module.exports = __webpack_public_path__ + "static/media/editor-speaker-view.d2ede297.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/img/editor-speaker-view.jpg
// module id = 1006
// module chunks = 4